import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const RE_CHECK_PLAYER_TAGS = ['IDV recheck Passed', 'IDV recheck Under review', 'IDV recheck Failed'];

export const VALIDATION_FIELDS_JUMIO_POPUP = [
    VALIDATION_FIELDS.firstname,
    VALIDATION_FIELDS.lastname,
    VALIDATION_FIELDS.dateOfBirth
];
